import { UnityBridge } from "@Context/common/general/context";

export const MINIMUM_LOADING_DURATION = 1000;
export const CONTENT_TRANSITION_DURATION = 400;

export const triggerTrainingFocusCompletionHaptics = () => {
  UnityBridge.dispatchWebEvent({
    type: UnityBridge.OutgoingWebEvents.TriggerHaptics,
    payload: {
      frequency: 0.25,
      amplitude: 0.1,
      duration: 0.5,
    },
  });
};
